var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"free-trial-reminder hide-in-mobile",class:{ alert: _vm.daysLeft < 7, danger: _vm.daysLeft < 3 }},[_vm._v(" "+_vm._s(_vm.$t('Trial X days left', { daysLeft: _vm.daysLeft }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }